var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLayer1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 563,
    height: 584,
    viewBox: "0 0 563 584",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.9359 236.399C44.7239 231.541 46.9515 227.214 49.6693 225.491C51.0548 224.604 52.192 224.801 52.957 225.358L51.7783 228.278C51.2082 227.955 50.6139 227.83 49.8314 228.319C48.372 229.247 47.2733 231.761 47.4021 234.703C47.5193 237.719 48.6309 238.825 50.2066 237.826C51.0737 237.276 51.7504 236.23 52.2394 235.14L53.6207 236.387C52.803 238.361 51.6478 239.87 50.2416 240.746C47.5238 242.469 45.1677 241.321 44.9359 236.399Z",
    fill: "url(#paint0_radial_3159_36778)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6761 221.308L59.5841 219.473L63.5608 231.991L61.0016 233.612L60.1946 230.553L56.9269 232.623L56.4224 236.528L53.9688 238.098L56.6761 221.308ZM57.2995 229.731L59.5837 228.283L59.2792 227.096C58.9132 225.824 58.5517 224.29 58.2082 222.924L58.1343 222.965C57.9486 224.688 57.7288 226.578 57.5025 228.228L57.2887 229.752L57.2995 229.731Z",
    fill: "url(#paint1_radial_3159_36778)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0977 216.576L66.509 215.037L67.0226 226.911L71.253 224.208L71.3844 226.994L64.7427 231.236L64.1184 216.587L64.0977 216.576Z",
    fill: "url(#paint2_radial_3159_36778)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6133 211.173L75.0246 209.633L75.5382 221.507L79.7686 218.805L79.9 221.591L73.2583 225.833L72.634 211.184L72.6133 211.173Z",
    fill: "url(#paint3_radial_3159_36778)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M84.6719 211.571L84.332 203.718L86.7748 202.168L87.1195 210.367C87.2492 213.257 87.9411 213.802 89.1463 213.058C90.3416 212.283 91.0036 210.861 90.8631 207.991L90.5185 199.793L92.845 198.314L93.185 206.168C93.3961 211.078 92.0371 214.142 89.2661 215.917C86.4951 217.691 84.8929 216.514 84.6926 211.582L84.6719 211.571Z",
    fill: "url(#paint4_radial_3159_36778)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M95 210.071L96.2769 206.912C97.086 207.333 98.1014 207.308 98.9893 206.768C99.9836 206.126 100.447 205.286 100.43 204.407C100.383 203.485 99.7747 203.59 98.8009 203.637L97.3662 203.707C96.2346 203.803 95.1458 203.21 95.0454 201.073C94.9394 198.644 96.4428 195.708 98.6639 194.28C99.8907 193.495 101.211 193.339 102.205 194.015L101.079 196.884C100.33 196.599 99.6716 196.599 98.8152 197.129C97.9796 197.669 97.4741 198.488 97.5125 199.325C97.55 200.215 98.274 200.091 99.2064 200.023L100.61 199.911C101.93 199.807 102.798 200.47 102.899 202.554C103.005 204.983 101.625 208.037 99.0667 209.658C97.6812 210.545 96.1709 210.76 95.0316 210.061L95 210.071Z",
    fill: "url(#paint5_radial_3159_36778)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M104.899 203.833C104.856 202.65 105.432 201.341 106.268 200.801C107.103 200.26 107.765 200.763 107.828 201.957C107.882 203.119 107.285 204.417 106.45 204.958C105.614 205.498 104.953 204.996 104.899 203.833ZM104.791 193.358L104.578 190.424L107.021 188.875L107.075 191.91L107.02 199.003L105.444 200.002L104.802 193.337L104.791 193.358Z",
    fill: "url(#paint6_radial_3159_36778)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M158.648 274.434L161.128 275.861L156.238 278.691L160.028 280.89L164.917 278.06L167.421 279.51L154.718 286.832L152.215 285.382L157.502 282.317L153.712 280.118L148.425 283.183L145.945 281.756L158.648 274.434Z",
    fill: "url(#paint7_linear_3159_36778)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M163.21 284.33C167.351 281.944 171.749 281.733 174.72 283.441C177.691 285.148 177.317 287.698 173.176 290.085C169.035 292.471 164.52 292.751 161.549 291.044C158.578 289.336 159.046 286.716 163.21 284.33ZM170.626 288.611C173.153 287.16 173.737 285.733 172.24 284.868C170.743 284.002 168.287 284.33 165.737 285.804C163.187 287.277 162.508 288.751 164.006 289.617C165.503 290.482 168.053 290.085 170.626 288.611Z",
    fill: "url(#paint8_linear_3159_36778)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M180.476 287.043L183.026 288.517L177.856 292.377C176.663 293.219 175.493 294.084 174.277 294.95L174.347 294.997C175.914 294.342 177.458 293.687 179.002 293.055L186.114 290.295L188.219 291.511L183.47 295.628C182.394 296.494 181.248 297.406 180.102 298.319L180.172 298.365C181.693 297.664 183.19 296.985 184.64 296.307L191.331 293.312L193.717 294.693L179.072 300.892L175.961 299.091L180.64 295.137C181.435 294.459 182.324 293.804 183.143 293.195L183.073 293.149C181.997 293.617 180.827 294.131 179.681 294.576L172.897 297.313L169.832 295.535L180.499 287.02L180.476 287.043Z",
    fill: "url(#paint9_linear_3159_36778)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M191.683 300.915C195.893 298.482 200.759 298.459 203.52 300.073C204.947 300.892 205.298 301.991 205.157 302.927L202.022 303.231C202.046 302.576 201.882 301.991 201.087 301.523C199.59 300.658 196.852 300.845 194.303 302.319C191.683 303.816 191.215 305.313 192.829 306.249C193.718 306.764 194.958 306.881 196.151 306.81L195.659 308.612C193.531 308.799 191.659 308.471 190.232 307.629C187.448 306.015 187.378 303.395 191.636 300.915H191.683Z",
    fill: "url(#paint10_linear_3159_36778)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M210.47 304.354L213.441 306.085L204.177 315.395L201.557 313.875L203.896 311.746L200.551 309.803L196.855 311.161L194.328 309.711L210.47 304.354ZM203.288 308.798L205.627 310.155L206.54 309.336C207.499 308.424 208.692 307.395 209.744 306.459L209.674 306.411C208.06 307.043 206.306 307.722 204.738 308.284L203.288 308.798Z",
    fill: "url(#paint11_linear_3159_36778)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M218.093 308.752L220.643 310.226L217.204 315.513L215.473 317.758L215.543 317.805C216.783 316.963 218.374 315.817 219.871 314.951L224.363 312.355L226.726 313.711L214.023 321.034L211.473 319.56L214.935 314.249L216.62 312.027L216.549 311.98C215.239 312.846 213.766 313.945 212.268 314.811L207.777 317.408L205.414 316.051L218.117 308.729L218.093 308.752Z",
    fill: "url(#paint12_linear_3159_36778)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M232.668 317.174L235.147 318.601L222.445 325.923L219.965 324.496L232.668 317.174Z",
    fill: "url(#paint13_linear_3159_36778)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M140.894 284.68L143.374 286.107L138.485 288.937L142.274 291.136L147.164 288.306L149.667 289.756L136.964 297.078L134.461 295.628L139.748 292.563L135.958 290.364L130.671 293.429L128.191 292.002L140.894 284.68Z",
    fill: "url(#paint14_linear_3159_36778)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M152.265 291.23L159.143 295.207L156.733 296.611L152.335 294.084L149.786 295.558L153.528 297.71L151.142 299.091L147.399 296.938L144.475 298.623L149.037 301.266L146.627 302.67L139.586 298.599L152.289 291.277L152.265 291.23Z",
    fill: "url(#paint15_linear_3159_36778)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M161.503 296.564L163.983 297.991L153.69 303.933L158.041 306.437L155.632 307.84L148.801 303.91L161.503 296.588V296.564Z",
    fill: "url(#paint16_linear_3159_36778)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M170.23 301.617L173.996 303.793C176.406 305.173 177.342 306.904 174.277 308.682C171.306 310.413 168.008 310.039 165.668 308.682L164.311 307.887L160.007 310.366L157.527 308.939L170.23 301.617ZM167.797 307.278C169.154 308.074 170.511 308.05 171.844 307.278C173.178 306.506 172.92 305.805 171.563 305.033L170.417 304.378L166.581 306.6L167.797 307.302V307.278Z",
    fill: "url(#paint17_linear_3159_36778)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M177.366 315.161L182.232 308.518L184.899 310.062L182.958 312.307C182.303 313.033 181.718 313.711 181.039 314.436L181.109 314.483C182.396 314.109 183.589 313.781 184.829 313.407L188.736 312.284L191.332 313.781L179.823 316.588L175.308 319.208L172.828 317.781L177.343 315.161H177.366Z",
    fill: "url(#paint18_linear_3159_36778)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M185.387 317.617C189.527 315.231 193.925 315.02 196.896 316.728C199.867 318.436 199.493 320.985 195.352 323.372C191.212 325.758 186.697 326.038 183.726 324.331C180.755 322.623 181.246 320.003 185.387 317.617ZM192.826 321.898C195.352 320.447 195.937 319.02 194.44 318.155C192.943 317.289 190.486 317.617 187.96 319.091C185.41 320.564 184.732 322.038 186.229 322.904C187.726 323.769 190.299 323.372 192.849 321.898H192.826Z",
    fill: "url(#paint19_linear_3159_36778)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M196.828 324.846L203.636 320.916L206.139 322.366L199.027 326.46C196.524 327.911 196.36 328.776 197.577 329.501C198.817 330.203 200.361 330.133 202.864 328.683L209.975 324.589L212.362 325.969L205.554 329.899C201.296 332.355 197.951 332.566 195.121 330.928C192.267 329.291 192.571 327.326 196.828 324.87V324.846Z",
    fill: "url(#paint20_linear_3159_36778)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M204.689 334.368C205.718 333.783 207.122 333.69 207.988 334.181C208.853 334.672 208.713 335.491 207.683 336.099C206.677 336.684 205.25 336.778 204.385 336.263C203.519 335.772 203.683 334.953 204.689 334.368ZM215.403 331.093C216.199 330.625 216.175 330.11 215.497 329.736C214.865 329.385 214.046 329.338 213.064 329.362L213.134 327.748C214.982 327.607 216.807 327.818 218.117 328.59C219.918 329.642 220.269 331.023 217.977 332.356C215.567 333.76 212.315 332.707 210.187 334.157L208.011 332.894C210.35 331.163 213.906 331.935 215.38 331.093H215.403Z",
    fill: "url(#paint21_linear_3159_36778)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M487.253 410.865C491.394 408.479 495.792 408.268 498.763 409.976C501.734 411.684 501.36 414.234 497.219 416.62C493.078 419.006 488.563 419.287 485.592 417.579C482.621 415.871 483.089 413.251 487.253 410.865ZM494.692 415.146C497.219 413.695 497.804 412.268 496.307 411.403C494.809 410.537 492.353 410.865 489.803 412.339C487.253 413.812 486.575 415.286 488.072 416.152C489.569 417.017 492.119 416.62 494.692 415.146Z",
    fill: "url(#paint22_radial_3159_36778)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M505.593 414.187L508.143 415.661L504.704 420.948L502.973 423.194L503.043 423.241C504.283 422.399 505.874 421.252 507.371 420.387L511.839 417.79L514.202 419.147L501.499 426.469L498.95 424.995L502.412 419.685L504.096 417.463L504.026 417.416C502.716 418.281 501.242 419.381 499.745 420.246L495.253 422.843L492.891 421.486L505.593 414.164V414.187Z",
    fill: "url(#paint23_radial_3159_36778)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M516.8 420.668L519.28 422.095L508.987 428.037L513.338 430.54L510.929 431.944L504.098 428.014L516.8 420.691V420.668Z",
    fill: "url(#paint24_radial_3159_36778)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M525.527 425.697L528.007 427.124L515.304 434.446L512.824 433.019L525.527 425.697Z",
    fill: "url(#paint25_radial_3159_36778)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M530.601 428.644L533.151 430.118L529.712 435.405L527.981 437.651L528.051 437.698C529.291 436.856 530.882 435.709 532.379 434.844L536.871 432.247L539.233 433.604L526.531 440.926L523.981 439.452L527.443 434.142L529.127 431.92L529.057 431.873C527.771 432.738 526.273 433.838 524.776 434.703L520.285 437.3L517.922 435.943L530.625 428.621L530.601 428.644Z",
    fill: "url(#paint26_radial_3159_36778)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M541.808 435.102L548.686 439.078L546.276 440.482L541.878 437.932L539.328 439.406L543.071 441.558L540.685 442.938L536.942 440.786L534.018 442.471L538.58 445.114L536.17 446.518L529.129 442.447L541.832 435.125L541.808 435.102Z",
    fill: "url(#paint27_radial_3159_36778)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M449.895 415.356L453.287 415.028C453.287 415.941 453.754 416.83 454.667 417.368C455.696 417.953 456.655 417.976 457.427 417.555C458.223 417.087 457.848 416.596 457.357 415.754L456.632 414.514C456.024 413.555 456.047 412.315 457.895 411.239C460.001 410.022 463.299 409.999 465.592 411.309C466.855 412.034 467.603 413.133 467.463 414.327L464.399 414.654C464.328 413.859 464.024 413.25 463.135 412.759C462.27 412.268 461.311 412.198 460.585 412.619C459.813 413.063 460.258 413.648 460.749 414.444L461.498 415.637C462.2 416.759 462.012 417.836 460.211 418.888C458.106 420.105 454.76 420.292 452.14 418.771C450.713 417.953 449.824 416.713 449.918 415.379L449.895 415.356Z",
    fill: "url(#paint28_radial_3159_36778)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M464.188 418.655L470.995 414.725L473.498 416.175L466.387 420.269C463.883 421.719 463.72 422.585 464.936 423.31C466.176 424.012 467.743 423.942 470.223 422.491L477.335 418.397L479.721 419.778L472.913 423.708C468.656 426.164 465.311 426.375 462.456 424.737C459.602 423.099 459.907 421.134 464.164 418.678L464.188 418.655Z",
    fill: "url(#paint29_radial_3159_36778)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M482.273 421.229L486.039 423.404C488.449 424.784 489.385 426.515 486.32 428.293C483.349 430.025 480.051 429.65 477.711 428.293L476.354 427.497L472.05 429.978L469.57 428.551L482.273 421.229ZM479.84 426.89C481.197 427.685 482.554 427.662 483.887 426.89C485.221 426.118 484.963 425.416 483.606 424.644L482.46 423.989L478.624 426.211L479.84 426.913V426.89Z",
    fill: "url(#paint30_radial_3159_36778)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M492.308 427.029L496.075 429.205C498.484 430.585 499.42 432.316 496.355 434.094C493.384 435.825 490.086 435.451 487.746 434.094L486.39 433.299L482.085 435.778L479.605 434.351L492.308 427.029ZM489.875 432.691C491.232 433.486 492.589 433.463 493.922 432.691C495.256 431.919 494.998 431.217 493.642 430.445L492.495 429.79L488.659 432.012L489.875 432.714V432.691Z",
    fill: "url(#paint31_radial_3159_36778)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M495.558 436.154C499.699 433.768 504.097 433.557 507.068 435.265C510.039 436.973 509.665 439.523 505.524 441.909C501.383 444.295 496.869 444.576 493.898 442.868C490.927 441.16 491.418 438.54 495.558 436.154ZM502.998 440.435C505.524 438.985 506.109 437.558 504.612 436.692C503.115 435.826 500.658 436.154 498.132 437.628C495.582 439.102 494.903 440.575 496.401 441.441C497.898 442.306 500.471 441.909 503.021 440.435H502.998Z",
    fill: "url(#paint32_radial_3159_36778)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M513.902 439.475L517.855 441.767C520.171 443.101 521.154 444.738 518.136 446.493C516.265 447.569 514.3 447.803 512.522 447.475L509.925 451.85L507.141 450.236L509.621 446.376L508.264 445.58L503.679 448.224L501.199 446.797L513.902 439.475ZM511.82 445.019C513.107 445.767 514.463 445.814 515.703 445.089C516.943 444.364 516.662 443.709 515.376 442.96L514.089 442.212L510.533 444.27L511.82 445.019Z",
    fill: "url(#paint33_radial_3159_36778)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M523.656 447.896L520.639 446.165L523.048 444.762L531.563 449.674L529.154 451.078L526.136 449.347L515.843 455.289L513.34 453.838L523.633 447.896H523.656Z",
    fill: "url(#paint34_radial_3159_36778)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M345.652 262.713L349.418 264.888C351.687 266.199 352.74 267.649 350.307 269.053C349.184 269.708 347.406 270.105 346.12 269.801L346.05 269.848C346.822 270.69 346.728 271.719 345.044 272.702C342.447 274.199 339.406 273.778 337.043 272.398L332.973 270.035L345.675 262.713H345.652ZM339.055 270.994C340.412 271.766 341.652 271.86 342.798 271.181C343.897 270.55 343.687 269.895 342.33 269.099L340.926 268.304L337.651 270.199L339.055 270.994ZM344.225 267.742C345.441 268.444 346.541 268.398 347.453 267.883C348.436 267.298 348.249 266.783 347.102 266.105L345.933 265.427L343.079 267.087L344.248 267.766L344.225 267.742Z",
    fill: "url(#paint35_linear_3159_36778)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M355.851 268.584L362.729 272.561L360.319 273.965L355.921 271.415L353.371 272.888L357.114 275.041L354.728 276.421L350.985 274.269L348.061 275.953L352.623 278.596L350.213 280L343.172 275.93L355.875 268.607L355.851 268.584Z",
    fill: "url(#paint36_linear_3159_36778)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M353.277 279.932L356.669 279.605C356.669 280.517 357.137 281.406 358.05 281.944C359.079 282.529 360.038 282.552 360.81 282.131C361.605 281.663 361.231 281.172 360.74 280.33L360.015 279.09C359.406 278.131 359.43 276.891 361.278 275.815C363.383 274.598 366.682 274.575 368.974 275.885C370.238 276.61 370.986 277.71 370.846 278.903L367.781 279.23C367.688 278.435 367.407 277.827 366.518 277.335C365.653 276.844 364.693 276.774 363.968 277.195C363.196 277.639 363.641 278.224 364.132 279.02L364.881 280.213C365.582 281.336 365.395 282.412 363.617 283.464C361.512 284.681 358.167 284.868 355.547 283.348C354.12 282.529 353.231 281.289 353.324 279.955L353.277 279.932Z",
    fill: "url(#paint37_linear_3159_36778)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M373.844 281.779L370.826 280.048L373.236 278.645L381.751 283.557L379.341 284.961L376.324 283.23L366.03 289.172L363.527 287.721L373.821 281.779H373.844Z",
    fill: "url(#paint38_linear_3159_36778)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M291.707 264.889L295.099 264.562C295.099 265.474 295.59 266.363 296.479 266.901C297.509 267.486 298.491 267.509 299.24 267.088C300.035 266.62 299.661 266.129 299.17 265.287L298.444 264.047C297.836 263.088 297.86 261.848 299.708 260.772C301.813 259.555 305.112 259.532 307.404 260.842C308.667 261.567 309.416 262.667 309.276 263.86L306.211 264.187C306.117 263.392 305.837 262.784 304.948 262.292C304.082 261.801 303.123 261.731 302.398 262.152C301.626 262.597 302.07 263.181 302.562 263.977L303.31 265.17C304.012 266.293 303.825 267.369 302.047 268.421C299.942 269.638 296.596 269.825 293.976 268.305C292.549 267.486 291.66 266.246 291.754 264.912L291.707 264.889Z",
    fill: "url(#paint39_linear_3159_36778)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M312.902 264.305L319.78 268.282L317.37 269.685L312.972 267.135L310.422 268.609L314.165 270.761L311.779 272.142L308.036 269.989L305.112 271.674L309.674 274.317L307.264 275.721L300.223 271.65L312.925 264.328L312.902 264.305Z",
    fill: "url(#paint40_linear_3159_36778)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M322.144 269.613L326.098 271.906C328.414 273.239 329.396 274.877 326.378 276.631C324.507 277.707 322.542 277.941 320.764 277.614L318.167 281.988L315.383 280.374L317.863 276.514L316.506 275.719L311.921 278.362L309.441 276.935L322.144 269.613ZM320.062 275.158C321.349 275.906 322.706 275.953 323.945 275.228C325.185 274.503 324.905 273.848 323.618 273.099L322.331 272.35L318.775 274.409L320.062 275.158Z",
    fill: "url(#paint41_linear_3159_36778)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M330.822 274.643L333.442 276.163L328.834 280.351C327.781 281.333 326.728 282.222 325.652 283.205L325.722 283.251C327.454 282.62 328.974 282.012 330.682 281.403L337.911 278.736L340.437 280.187L324.436 285.614L321.465 283.883L330.846 274.643H330.822Z",
    fill: "url(#paint42_linear_3159_36778)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M341.605 280.865L344.085 282.292L331.382 289.614L328.902 288.187L341.605 280.865Z",
    fill: "url(#paint43_linear_3159_36778)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M339.733 287.206C343.944 284.773 348.787 284.75 351.57 286.364C352.974 287.183 353.348 288.282 353.208 289.218L350.073 289.522C350.097 288.867 349.933 288.282 349.138 287.814C347.64 286.949 344.903 287.136 342.353 288.61C339.733 290.107 339.265 291.604 340.88 292.54C341.769 293.055 343.008 293.172 344.202 293.078L343.734 294.879C341.605 295.066 339.733 294.739 338.306 293.897C335.522 292.283 335.452 289.663 339.71 287.183L339.733 287.206Z",
    fill: "url(#paint44_linear_3159_36778)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M356.484 289.477L363.362 293.453L360.952 294.857L356.554 292.331L354.004 293.804L357.747 295.957L355.361 297.337L351.618 295.185L348.694 296.869L353.256 299.512L350.846 300.916L343.805 296.846L356.507 289.523L356.484 289.477Z",
    fill: "url(#paint45_linear_3159_36778)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M361.703 487L368.627 491L366.218 492.404L361.773 489.831L358.825 491.538L362.638 493.737L360.229 495.141L356.416 492.942L351.48 495.796L349 494.369L361.703 487.047V487Z",
    fill: "url(#paint46_radial_3159_36778)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M363.55 495.328C367.691 492.942 372.089 492.731 375.06 494.439C378.031 496.147 377.656 498.696 373.516 501.083C369.375 503.469 364.86 503.749 361.889 502.042C358.918 500.334 359.386 497.714 363.55 495.328ZM370.989 499.609C373.516 498.158 374.101 496.731 372.603 495.866C371.106 495 368.65 495.328 366.1 496.802C363.55 498.275 362.872 499.749 364.369 500.615C365.866 501.48 368.416 501.083 370.989 499.609Z",
    fill: "url(#paint47_radial_3159_36778)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M381.89 498.65L385.844 500.943C388.16 502.276 389.142 503.914 386.124 505.668C384.253 506.745 382.288 506.978 380.51 506.651L377.913 511.026L375.129 509.411L377.609 505.551L376.252 504.756L371.667 507.4L369.188 505.973L381.89 498.65ZM379.808 504.195C381.095 504.943 382.452 504.99 383.691 504.265C384.931 503.54 384.651 502.885 383.364 502.136L382.077 501.387L378.522 503.446L379.808 504.195Z",
    fill: "url(#paint48_radial_3159_36778)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M388.651 509.974C392.862 507.541 397.728 507.517 400.488 509.132C401.915 509.95 402.266 511.05 402.126 511.986L398.991 512.29C399.015 511.635 398.851 511.05 398.056 510.582C396.558 509.716 393.821 509.904 391.271 511.377C388.651 512.875 388.183 514.372 389.798 515.308C390.687 515.822 391.926 515.939 393.119 515.869L392.652 517.67C390.523 517.857 388.651 517.53 387.224 516.688C384.44 515.074 384.37 512.454 388.628 509.974H388.651Z",
    fill: "url(#paint49_radial_3159_36778)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M398.219 515.961L405.026 512.031L407.53 513.482L400.418 517.576C397.915 519.026 397.751 519.892 398.967 520.617C400.207 521.319 401.751 521.248 404.254 519.798L411.366 515.704L413.752 517.084L406.945 521.014C402.687 523.471 399.342 523.681 396.511 522.044C393.657 520.406 393.961 518.441 398.219 515.985V515.961Z",
    fill: "url(#paint50_radial_3159_36778)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M404.324 524.43L407.716 524.103C407.716 525.015 408.184 525.904 409.096 526.442C410.126 527.027 411.085 527.05 411.857 526.629C412.652 526.161 412.278 525.67 411.787 524.828L411.062 523.588C410.453 522.629 410.477 521.389 412.325 520.313C414.43 519.096 417.729 519.073 420.021 520.383C421.285 521.108 422.033 522.208 421.893 523.401L418.828 523.728C418.735 522.933 418.431 522.325 417.565 521.833C416.699 521.342 415.74 521.272 415.015 521.693C414.243 522.138 414.688 522.722 415.179 523.518L415.927 524.711C416.629 525.834 416.442 526.91 414.664 527.963C412.559 529.179 409.213 529.366 406.593 527.846C405.166 527.027 404.277 525.787 404.371 524.453L404.324 524.43Z",
    fill: "url(#paint51_radial_3159_36778)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M424.91 526.279L421.893 524.547L424.302 523.145L432.817 528.057L430.408 529.461L427.39 527.729L417.097 533.672L414.594 532.221L424.887 526.279H424.91Z",
    fill: "url(#paint52_radial_3159_36778)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M427.273 532.103C431.413 529.717 435.811 529.506 438.782 531.214C441.753 532.922 441.379 535.472 437.238 537.858C433.098 540.244 428.583 540.525 425.612 538.817C422.641 537.109 423.109 534.489 427.273 532.103ZM434.712 536.384C437.238 534.934 437.823 533.507 436.326 532.641C434.829 531.776 432.373 532.103 429.823 533.577C427.273 535.051 426.594 536.525 428.092 537.39C429.589 538.256 432.139 537.858 434.712 536.384Z",
    fill: "url(#paint53_radial_3159_36778)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M445.617 535.447L448.331 537.015L444.447 541.296C443.933 541.857 443.301 542.442 442.739 543.003L442.81 543.05C443.816 542.723 444.821 542.372 445.781 542.068L453.173 539.798L455.863 541.366L443.161 548.688L440.915 547.378L445.57 544.688C446.81 543.963 448.869 543.027 450.225 542.372L450.155 542.325L446.248 543.565L439.839 545.46L438.482 544.664L441.757 540.968L443.909 538.722L443.839 538.676C442.716 539.448 441.079 540.641 439.839 541.366L435.183 544.056L432.961 542.769L445.664 535.447H445.617Z",
    fill: "url(#paint54_radial_3159_36778)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M458.461 542.863L465.338 546.84L462.929 548.244L458.531 545.717L455.981 547.191L459.724 549.343L457.338 550.724L453.595 548.571L450.671 550.256L455.232 552.899L452.823 554.303L445.781 550.232L458.484 542.91L458.461 542.863Z",
    fill: "url(#paint55_radial_3159_36778)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M467.675 548.174L471.629 550.466C473.945 551.8 474.927 553.437 471.91 555.192C470.038 556.268 468.073 556.502 466.295 556.174L463.698 560.549L460.915 558.935L463.394 555.075L462.038 554.28L457.452 556.923L454.973 555.496L467.675 548.174ZM465.593 553.718C466.88 554.467 468.237 554.513 469.477 553.788C470.717 553.063 470.436 552.408 469.149 551.659L467.862 550.911L464.307 552.969L465.593 553.718Z",
    fill: "url(#paint56_radial_3159_36778)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M465.969 560.012L469.361 559.685C469.361 560.597 469.852 561.486 470.741 562.024C471.77 562.609 472.729 562.632 473.501 562.211C474.297 561.743 473.923 561.252 473.431 560.41L472.706 559.17C472.098 558.211 472.121 556.971 473.969 555.895C476.075 554.678 479.373 554.655 481.666 555.965C482.929 556.69 483.678 557.79 483.537 558.983L480.473 559.31C480.379 558.515 480.098 557.907 479.21 557.415C478.344 556.924 477.385 556.854 476.66 557.275C475.888 557.72 476.332 558.304 476.823 559.1L477.572 560.293C478.274 561.416 478.087 562.492 476.309 563.545C474.203 564.761 470.858 564.948 468.238 563.428C466.811 562.609 465.922 561.369 466.016 560.036L465.969 560.012Z",
    fill: "url(#paint57_radial_3159_36778)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_3159_36778",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.2783 226.84) rotate(-82.3203) scale(32.6751 12.3556)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_3159_36778",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(58.9979 222.46) rotate(-82.4252) scale(36.9931 14.05)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_3159_36778",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(66.5186 217.657) rotate(-87.4892) scale(30.4816 13.8321)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_3159_36778",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(75.0342 212.254) rotate(-87.4892) scale(30.4815 13.8321)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_3159_36778",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(89.3172 199.772) rotate(-82.4533) scale(37.032 14.0813)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_3159_36778",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(99.4072 195.568) rotate(-81.279) scale(33.7986 12.2122)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_3159_36778",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(106.48 191.194) rotate(-82.381) scale(29.214 11.075)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3159_36778",
    x1: 147.365,
    y1: 288.165,
    x2: 166.542,
    y2: 275.634,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3159_36778",
    x1: 160.77,
    y1: 293.189,
    x2: 175.955,
    y2: 283.253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_3159_36778",
    x1: 171.411,
    y1: 302.383,
    x2: 192.816,
    y2: 288.479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_3159_36778",
    x1: 189.388,
    y1: 309.706,
    x2: 204.436,
    y2: 299.809,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_3159_36778",
    x1: 195.592,
    y1: 316.581,
    x2: 212.666,
    y2: 305.432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_3159_36778",
    x1: 206.823,
    y1: 322.356,
    x2: 225.855,
    y2: 309.921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_3159_36778",
    x1: 220.969,
    y1: 326.864,
    x2: 234.511,
    y2: 317.998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_3159_36778",
    x1: 129.611,
    y1: 298.411,
    x2: 148.788,
    y2: 285.88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_3159_36778",
    x1: 140.879,
    y1: 303.9,
    x2: 158.479,
    y2: 292.548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_3159_36778",
    x1: 149.805,
    y1: 309.052,
    x2: 165.183,
    y2: 301.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_3159_36778",
    x1: 158.763,
    y1: 311.307,
    x2: 173.201,
    y2: 299.673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_3159_36778",
    x1: 174.052,
    y1: 320.358,
    x2: 190.583,
    y2: 309.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_3159_36778",
    x1: 182.953,
    y1: 326.477,
    x2: 198.135,
    y2: 316.546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_3159_36778",
    x1: 194.517,
    y1: 333.174,
    x2: 211.614,
    y2: 322.039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_3159_36778",
    x1: 204.866,
    y1: 337.555,
    x2: 218.743,
    y2: 328.276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_3159_36778",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(498.106 411.16) rotate(-19.908) scale(32.933 12.4885)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_3159_36778",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(510.946 417.052) rotate(-19.9346) scale(41.2466 15.6585)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_3159_36778",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(516.961 423.314) rotate(-25.0091) scale(30.4817 13.8321)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_3159_36778",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(525.687 427.751) rotate(-19.8991) scale(29.3776 11.1361)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_radial_3159_36778",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(535.978 431.509) rotate(-19.9345) scale(41.2466 15.6585)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial_3159_36778",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(545.698 437.781) rotate(-20.1362) scale(37.8992 14.5086)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial_3159_36778",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(464.793 412.563) rotate(-18.7991) scale(33.7987 12.2122)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint29_radial_3159_36778",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(476.798 417.322) rotate(-19.9717) scale(37.0351 14.0815)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint30_radial_3159_36778",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(485.402 423.282) rotate(-16.388) scale(35.44 11.3621)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint31_radial_3159_36778",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(495.438 429.083) rotate(-16.388) scale(35.44 11.362)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint32_radial_3159_36778",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(506.413 436.449) rotate(-19.9158) scale(32.9206 12.4879)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint33_radial_3159_36778",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(517.148 442.379) rotate(-22.4377) scale(37.0549 15.4833)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint34_radial_3159_36778",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(528.779 447.232) rotate(-19.9434) scale(35.272 13.3953)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_3159_36778",
    x1: 334.211,
    y1: 274.821,
    x2: 351.044,
    y2: 263.943,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_3159_36778",
    x1: 344.465,
    y1: 281.227,
    x2: 362.044,
    y2: 269.866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_3159_36778",
    x1: 354.44,
    y1: 285.457,
    x2: 369.534,
    y2: 274.949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_3159_36778",
    x1: 364.732,
    y1: 290.303,
    x2: 381.011,
    y2: 279.672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_3159_36778",
    x1: 292.87,
    y1: 270.414,
    x2: 307.964,
    y2: 259.906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_3159_36778",
    x1: 301.516,
    y1: 276.948,
    x2: 319.094,
    y2: 265.587,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_3159_36778",
    x1: 310.686,
    y1: 283.319,
    x2: 328.731,
    y2: 272.963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_3159_36778",
    x1: 322.719,
    y1: 286.794,
    x2: 339.678,
    y2: 275.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_3159_36778",
    x1: 329.906,
    y1: 290.555,
    x2: 343.449,
    y2: 281.689,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_3159_36778",
    x1: 337.461,
    y1: 295.971,
    x2: 352.478,
    y2: 286.085,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_3159_36778",
    x1: 345.098,
    y1: 302.146,
    x2: 362.698,
    y2: 290.794,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint46_radial_3159_36778",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(365.629 489.064) rotate(-15.722) scale(37.0985 11.4611)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint47_radial_3159_36778",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(374.403 495.623) rotate(-19.908) scale(32.933 12.4885)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint48_radial_3159_36778",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(385.136 501.555) rotate(-22.4377) scale(37.0549 15.4833)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint49_radial_3159_36778",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(399.574 510.295) rotate(-19.8404) scale(32.6752 12.3556)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint50_radial_3159_36778",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(410.833 514.629) rotate(-19.9942) scale(36.9952 14.0795)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint51_radial_3159_36778",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(419.223 521.637) rotate(-18.7992) scale(33.7986 12.2122)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint52_radial_3159_36778",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(430.033 525.615) rotate(-19.9434) scale(35.272 13.3953)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint53_radial_3159_36778",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(438.126 532.399) rotate(-19.908) scale(32.933 12.4885)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint54_radial_3159_36778",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(452.364 538.555) rotate(-19.9584) scale(44.3321 16.8467)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint55_radial_3159_36778",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(462.35 545.548) rotate(-20.174) scale(37.9086 14.5348)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint56_radial_3159_36778",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(470.921 551.078) rotate(-22.4377) scale(37.0549 15.4833)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint57_radial_3159_36778",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(480.867 557.219) rotate(-18.799) scale(33.7987 12.2122)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayer1);
export default __webpack_public_path__ + "static/media/layer1.514e74a0f7bfdf0ae11fdce1391aabc1.svg";
export { ForwardRef as ReactComponent };